// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"b39f26d8","66":"253aed93","211":"c70fe6d9","213":"9e3a03b1","298":"c0b487f2","397":"466b6a56","402":"16ed3247","464":"f6170eef","685":"a9b79d4b","687":"0f879764","856":"7a64d744","932":"d243065c","960":"51832a0e"}[chunkId] + ".chunk.js";
};